import {IHttpService} from "angular";
import {TradingAccountDetailsRecords} from "../types/TradingAccountDetailRecord";
import {EquityAccountId} from "../equity/types/EquityAccountRecord";

export class TradingAccountDetailService {

    public static readonly id = "tradingAccountDetailService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async detail(accountId: EquityAccountId): Promise<TradingAccountDetailsRecords> {
        const url = `/tradefloor/api/trading-account-detail/${accountId}`;
        const response = await this.$http.get<TradingAccountDetailsRecords>(url);
        return response.data;
    }
}
